<template lang="pug">
div
  v-row.no-gutters.align-center.wrap.justify-end
    v-col(cols="12", md="2")
      v-text-field.mr-1(
        v-model="filters.datainicial",
        color="primary",
        label="Data/Hora inicial",
        type="datetime-local",
        hide-details,
        dense,
        outlined
      )
    v-col(cols="12", md="2")
      v-text-field.mr-1(
        v-model="filters.datafinal",
        color="primary",
        label="Data/Hora final",
        type="datetime-local",
        hide-details,
        dense,
        outlined
      )
    v-btn.mx-1(
      :disabled="loading",
      :loading="loading",
      outlined,
      icon,
      color="primary",
      title="Atualizar",
      @click="getLogs"
    )
      v-icon(small) fa-sync
    v-btn.mx-1(
      :disabled="loading",
      outlined,
      icon,
      color="primary",
      title="Dashboard",
      @click="() => { tipoVisualizacao = 'Dashboard'; getLogs(); }"
    )
      v-icon(small) fa-chart-line
    v-btn.ml-1.mr-2(
      outlined,
      icon,
      color="primary",
      title="Grid",
      @click="tipoVisualizacao = 'Dados'"
    )
      v-icon(small) fa-table
  v-divider
  div(v-if="tipoVisualizacao === 'Dashboard'")
    v-card.elevation-2.csapi-log-dashboard
      v-row.pa-0.pt-0.mt-0(no-gutters)
        v-col.mt-0(cols="12", xs="12", sm="12", md="5")
          Chart(
            chartType="pie",
            height="90%",
            width="90%",
            title="Total de requisições por status",
            :labels="dashStatus.labels",
            :dataset="dashStatus.values"
          )
        v-col.mt-0(cols="12", xs="12", sm="12", md="5")
          Chart(
            chartType="pie",
            height="90%",
            width="90%",
            title="Total de requisições por tipo",
            :labels="dashType.labels",
            :dataset="dashType.values"
          )
        v-col.mt-0(cols="12", xs="12", sm="12", md="2")
          v-card.mx-2.mb-2
            v-card-title.mx-2
              span.title Total de requisições
            v-card-text.mx-2
              span.title {{ dashTotalRequests }}
          v-card.mx-2.mb-2
            v-card-title.mx-2
              span.title Tempo médio de resposta
            v-card-text.mx-2
              span.title {{ dashResponseTime }} ms

  DataFilter.csapi-log-filter(
    v-if="tipoVisualizacao === 'Dados'",
    :items="logs",
    :filterProps="filterProps"
  )
    template(v-slot:default="{ items }")
      v-data-table.csapi-log-table(
        :headers="headers",
        :items="items",
        :loading="loading",
        :items-per-page="items.length",
        dense,
        fixed-header,
        hide-default-footer
      )
        template(v-slot:item.data_hora="{ item }")
          span.csapi-log-nowrap {{ formatDate(item.data_hora) }}
        template(v-slot:item.user_agent="{ item }")
          .csapi-log-ellipsis(:title="item.user_agent") {{ item.user_agent }}
        template(v-slot:item.rota="{ item }")
          .csapi-log-ellipsis(:title="item.rota") {{ item.rota }}
        template(v-slot:item.message="{ item }")
          .csapi-log-ellipsis(:title="item.message") {{ item.message }}
        template(v-slot:item.metodo="{ item }")
          v-chip(small, label, outlined) {{ item.metodo }}
        template(v-slot:item.duracao="{ item }")
          span {{ item.duracao }} ms
        template(v-slot:item.status="{ item }")
          v-chip(
            :color="getColorByStatus(item.status)",
            :text-color="getColorByStatus(item.status)",
            small,
            label,
            outlined
          ) {{ item.status }}
</template>

<script>
import api from "@/api/csapi";
import { ultimaHoraLocal, periodoParaISO } from "@/utils/tempo";

export default {
  name: "ApiLogs",
  props: {
    // true quando a aba está visível
    active: { type: Boolean, default: false }
  },
  watch: {
    active(isActive) {
      if (isActive && !this.loading) {
        Object.assign(this.filters, ultimaHoraLocal());
        this.getLogs();
      }
    }
  },
  data: () => ({
    tipoVisualizacao: "Dados",
    loading: false,
    headers: [
      { text: "Data", value: "data_hora" },
      { text: "IP", value: "ip" },
      { text: "User Agent", value: "user_agent" },
      { text: "Método", value: "metodo" },
      { text: "Rota", value: "rota" },
      { text: "Status", value: "status" },
      { text: "Duração", value: "duracao" },
      { text: "Mensagem", value: "message" }
    ],
    filterProps: {},
    filters: {
      ...ultimaHoraLocal(),
      type: null,
      ip: null,
      status: null
    },
    logs: [],
    dashStatus: {
      labels: [],
      values: []
    },
    dashType: {
      labels: [],
      values: []
    },
    dashResponseTime: 0,
    dashTotalRequests: 0,
    dashResponseTimeByDate: {
      labels: [],
      values: []
    }
  }),
  computed: {
    //
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString();
    },

    getColorByStatus(status) {
      if (status >= 200 && status < 300) {
        return "success";
      }
      if (status >= 300 && status < 400) {
        return "warning";
      }
      if (status >= 400 && status < 500) {
        return "error";
      }
      if (status >= 500) {
        return "error darken-2";
      }
    },

    mountDashboards() {
      this.dashStatus.labels = this.logs
        .map(item => item.status)
        .sort()
        .filter((item, index, self) => self.indexOf(item) === index);

      this.dashStatus.values = this.dashStatus.labels.map(
        item => this.logs.filter(log => log.status === item).length
      );

      this.dashType.labels = this.logs
        .map(item => item.metodo)
        .sort()
        .filter((item, index, self) => self.indexOf(item) === index);

      this.dashType.values = this.dashType.labels.map(
        item => this.logs.filter(log => log.metodo === item).length
      );

      this.dashResponseTime = this.logs.length
        ? Math.round(this.logs.reduce((acc, item) => acc + item.duracao, 0) / this.logs.length)
        : 0;

      this.dashTotalRequests = this.logs.length;
    },

    mountDataFilters() {
      const statusses = this.logs
        .map(item => item.status)
        .sort()
        .map(item => ({
          field: "status",
          text: item,
          value: item
        }));

      this.filterProps = {
        includeSearch: true,
        searchText: this.filterProps.searchText || "",
        items: [
          {
            text: "IP",
            type: "select",
            values: this.logs
              .map(item => item.ip)
              .sort()
              .map(item => ({
                field: "ip",
                text: item,
                value: item
              }))
          },
          {
            text: "User Agent",
            type: "select",
            values: this.logs
              .map(item => item.user_agent)
              .sort()
              .map(item => ({
                field: "user_agent",
                text: item,
                value: item
              }))
          },
          {
            text: "Método",
            type: "select",
            values: this.logs
              .map(item => item.metodo)
              .sort()
              .map(item => ({
                field: "metodo",
                text: item,
                value: item
              }))
          },
          {
            text: "Status",
            type: "select",
            values: statusses
          }
        ]
      };
    },

    async getLogs() {
      const { datainicial, datafinal } = this.filters;
      if (!datainicial || !datafinal) {
        this.$toast.error("Informe a data/hora inicial e final");
        return;
      }
      if (new Date(datainicial) > new Date(datafinal)) {
        this.$toast.error("A data/hora inicial deve ser anterior à final");
        return;
      }

      // Uma busca por vez
      if (this.loading) return;
      this.loading = true;
      try {
        const res = await api.post("/__internals__/logs/api", {
          ...this.filters,
          ...periodoParaISO(this.filters)
        });
        this.logs = res.data.sort((a, b) => new Date(b.data_hora) - new Date(a.data_hora));

        this.mountDashboards();
        this.mountDataFilters();
      } catch (error) {
        console.error(error);
        this.logs = [];
        this.mountDashboards();
        this.mountDataFilters();
        this.$toast.error(`Erro ao carregar logs: ${error.message}`);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    // Chips e busca visíveis antes da primeira carga
    this.mountDataFilters();
    this.getLogs();
  }
};
</script>
